/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// core components
import styles from "assets/jss/material-kit-react/views/componentsSections/downloadStyle.js";

const useStyles = makeStyles(styles);

export default function SectionDownload() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <GridContainer className={classes.textCenter} justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2>Do you love what you seeing so far?</h2>
            <h4>
              Do email if you have any question's. Also do check my Linkedin and
              Medium. I use Medium to publish some Article for such topics
              because I use to Learn about these of free time: Leadership,
              Sales Strategy, Personal Finanace.
            </h4>
          </GridItem>
        </GridContainer>
        <br />
        <br />

        <div className={classes.textCenter + " " + classes.sharingArea}>
          <GridContainer justify="center">
            <h3>Thank you for your support!!!</h3>
          </GridContainer>
          <Button color="white">
            <a
              className={classes.navLink}
              target="_blank"
              color="rose"
              href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=mehrotra.rachit.io@gmail.com"
            >
              <i className={classes.socials + " fab fa-google"} /> Mail
            </a>
          </Button>
          <p>mehrotra.rachit.io@gmail.com</p>
        </div>
      </div>
    </div>
  );
}
